export default theme => ({
  terms: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2)
  }
})
